import React, { useState, useEffect } from 'react';
import { Bell, Wifi } from 'lucide-react';

export default function TopBar({ user, activeAlerts }) {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="top-bar">
      <div className="top-bar-left">
        <div className="live-indicator">
          <span className="live-dot"></span>
          LIVE
        </div>
        <span style={{ fontFamily: 'var(--font-display)', fontSize: 13, color: 'var(--text-muted)' }}>
          {time.toLocaleTimeString('en-US', { hour12: false })}
        </span>
        <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
          {time.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
        </span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 6, padding: '4px 12px',
          background: activeAlerts > 0 ? 'rgba(239, 68, 68, 0.12)' : 'rgba(16, 185, 129, 0.12)',
          borderRadius: 20, fontSize: 12, fontWeight: 700,
          color: activeAlerts > 0 ? 'var(--accent-red)' : 'var(--accent-emerald)',
          fontFamily: 'var(--font-display)'
        }}>
          <Bell size={13} />
          {activeAlerts} ACTIVE
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4, color: 'var(--accent-emerald)', fontSize: 11 }}>
          <Wifi size={13} /> Connected
        </div>
      </div>
    </div>
  );
}
